<template>
  <CModal
    class="modal__footer-empty edit-auction-modal"
    size="lg"
    :close-on-backdrop="false"
    :show="show"
    @update:show="closeModal"
  >
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">{{ title }}</span> <CBadge class="ml-2" :color="statusColor">{{status}}</CBadge>
      </div>

      <CButtonClose @click="closeModal"/>
    </template>

    <VAuctionForm
      :auction="selectedAuction"
      :show="show"
      @success="onSuccess"
    />
  </CModal>
</template>
<script>
import VAuctionForm from "@/components/Forms/VAuctionForm";
import { modalStore } from "@/mixins/modalsMixin";
import { getStatus, getStatusColor } from '@/utils/validation/car';

export default {
  name: "TheEditAuctionModal",

  components: {
    VAuctionForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    title() {
      return this.selectedAuction?.title;
    },
    selectedAuction() {
      return this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`] || {};
    },
    status() {
      return getStatus(this.selectedAuction)
    },
    statusColor() {
      return getStatusColor(this.status)
    }
  },

  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>